/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_My_GroupsInputs */

const en_us2_coaching_my_groups = /** @type {(inputs: Coaching_My_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My groups`)
};

const pt_br2_coaching_my_groups = /** @type {(inputs: Coaching_My_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas turmas`)
};

const pt_pt2_coaching_my_groups = /** @type {(inputs: Coaching_My_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas turmas`)
};

/** @type {(inputs: Coaching_My_GroupsInputs) => LocalizedString} */
const es_419_coaching_my_groups = en_us2_coaching_my_groups;

/** @type {(inputs: Coaching_My_GroupsInputs) => LocalizedString} */
const fr_fr2_coaching_my_groups = en_us2_coaching_my_groups;

/** @type {(inputs: Coaching_My_GroupsInputs) => LocalizedString} */
const de_de2_coaching_my_groups = en_us2_coaching_my_groups;

/** @type {(inputs: Coaching_My_GroupsInputs) => LocalizedString} */
const it_it2_coaching_my_groups = en_us2_coaching_my_groups;

/**
* | output |
* | --- |
* | "My groups" |
*
* @param {Coaching_My_GroupsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_my_groups = /** @type {((inputs?: Coaching_My_GroupsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_My_GroupsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_my_groups(inputs)
	if (locale === "es-419") return es_419_coaching_my_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_my_groups(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_my_groups(inputs)
	if (locale === "de-DE") return de_de2_coaching_my_groups(inputs)
	if (locale === "it-IT") return it_it2_coaching_my_groups(inputs)
	return en_us2_coaching_my_groups(inputs)
});
export { coaching_my_groups as "coaching.my_groups" }